import React, { useEffect, useState, useSyncExternalStore } from "react";
import Card from "../../components/common/Card";
import "./StaffManagement.css";
import {
  getdriversList,
  getShiftDetails1,
  getSiteDetails,
  saveDetailsTrips,
  uploadfilesgeneric,
  vehicleListVendors,
  vehicleTypes,
} from "../../services/vehicleService";
import { withErrorHandler } from "../../utils/tryCatchHandler";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import { useFormik } from "formik";
import InfoIcon from "@mui/icons-material/Info";

import {
  Autocomplete,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Pagination,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { AutoComplete, Avatar, DatePicker, Grid, IconButton } from "rsuite";
import { toast } from "react-toastify";
import TripDetailsForm from "../../components/common/TripDetailForm";
import Modal from "../../components/modals/ReusableModal";
import BootstrapModal from "../../components/modals/ReusableModal";
import DetailModal from "../../components/modals/DetailModal";
import moment from "moment";
import { add } from "date-fns";
import { setAesKey, setLoader } from "../../redux/features/authSliceandSidebar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { DatePicker } from "rsuite";
const StaffManagement = () => {
  function generate(element) {
    return [0, 1, 2].map((value) =>
      React.cloneElement(element, {
        key: value,
      })
    );
  }
  const Demo = styled("div")(({ theme }) => ({
    backgroundColor: (theme.vars || theme).palette.background.paper,
  }));
  const [activeTab, setActiveTab] = useState("");
  const [dense, setDense] = React.useState(false);
  const [key, setKey] = useState(0);

  const [singleArray, setSingleArray] = useState([]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeId, setActiveId] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [selectedRadio, setSelectedRadio] = useState("active");
  const [showModal, setShowModal] = useState(false);
  const [previousData, setPreviousData] = useState(null);
  const [formData, setFormData] = useState({
    employeeType: "permanent",
    department: "",
    employeeId: "",
    fullName: "",
    contact: "",
    email: "",
  });

  const [detailObj, setDetailObj] = useState(null);
  const [addedList, setAddedList] = useState([]);
  const [portalFields, setPortalfields] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [sitesList, setSitesLsit] = useState([]);
  const [showIndex, setShowIndex] = useState(0);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [shiftList, setShiftList] = useState([]);
  const [paginationPage, setPaginationPage] = useState(0);
  const [vehicleList, setVehicleList] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [responseList, setResponseList] = useState([]);
  const [vehicleVendorList, setVehicleVendorList] = useState([]);
  const [uploadfiles, setUploadfiles] = useState([]);

  const [driverList, setDriverList] = useState([]);

  const [searchState, setSearchState] = useState(null);
  const [forceHit, setForcehit] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();
  const isLogin = useSelector((x) => x.authSliceandSidebar.isLogin);
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form submitted:", formData);
  };

  const getShiftDetails = async () => {
    setShiftList([]);
    withErrorHandler(
      await getShiftDetails1().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setShiftList(res.data.shiftDetails);
          formik.setFieldValue("shiftId", res.data.shiftDetails[0].shiftId);

          formik.setFieldValue("shiftName", res.data.shiftDetails[0].name);

          // setSelectedRadio(res.data.shiftDetails[0].shiftId);
        } else {
        }
      })
    );
  };

  const getVehiclees = async () => {
    setVehicleList([]);
    withErrorHandler(
      await vehicleTypes().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setVehicleList(res.data.data);

          if (localStorage.getItem("vehicleName") != null) {
            setActiveTab(localStorage.getItem("vehicleName"));
            setActiveId(localStorage.getItem("vehicleTypeId"));
            formik.setFieldValue(
              "vehicleTypeId",
              localStorage.getItem("vehicleTypeId")
            );
            formik.setFieldValue(
              "vehicleName",
              localStorage.getItem("vehicleName")
            );
          } else {
            setActiveTab(res.data.data[0].name);
            setActiveId(res.data.data[0].vehicleTypeId);
            formik.setFieldValue(
              "vehicleTypeId",
              res.data.data[0].vehicleTypeId
            );
            formik.setFieldValue("vehicleName", res.data.data[0].name);
          }
          // setActiveTab(res.data.data[0].name);
          // setActiveId(res.data.data[0].vehicleTypeId);

          // formik.setFieldValue("vehicleTypeId", res.data.data[0].vehicleTypeId);
          // formik.setFieldValue("vehicleName", res.data.data[0].name);
          // setSelectedRadio(res.data.shiftDetails[0].shiftId);
        } else {
        }
      })
    );
  };
  const getSites = async () => {
    setSitesLsit([]);
    withErrorHandler(
      await getSiteDetails().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          // console.log(res.data);
          setSitesLsit(res.data.siteDetails);
          formik.setFieldValue(
            "tripDate",
            moment(new Date()).format("YYYY-MM-DD")
          );
          formik.setFieldValue("siteIdState", res.data.siteDetails[0]);
          formik.setFieldValue("siteId", res.data.siteDetails[0].siteId);
        } else if (res && res.data.statusDescription?.statusCode == 401) {
          dispatch(setLoader(false));
        }
      })
    );
  };

  // const getDriverList = async (id) => {

  // };

  useEffect(() => {
    if (isLogin) {
      setKey(Math.random());
      dispatch(setLoader(true));
      setKey(Math.random());
      getVehiclees();
    }
  }, [isLogin]);

  const getVendorDetails = async (id) => {
    dispatch(setLoader(true));
    setVehicleVendorList([]);
    setKey(Math.random());
    setAddedList([]);
    if (formik.values.shiftId == null) {
      return;
    }

    let formdata = {
      vehicleTypeId: formik.values.vehicleTypeId,
      shiftId: formik.values.shiftId,
      siteId: formik.values.siteId,
      tripDate: formik.values.tripDate,
      fieldCategory: formik.values.vehicleName,
      fieldMenu: "Add Trip Details",
    };

    await vehicleListVendors(formdata).then((res) => {
      dispatch(setLoader(false));
      if (res && res.data?.statusDescription?.statusCode == 200) {
        setVehicleVendorList(res.data.vehicleDetails);
        let portalFields = res.data.portalFields;
        let driverList = [];
        getdriversList(formik.values.vehicleTypeId).then((res) => {
          if (res && res.data.statusDescription?.statusCode == 200) {
            console.log(res.data);
            driverList = res.data.driverDetailList;

            setDriverList(res.data.driverDetailList);

            let arr = portalFields.map((x) => {
              if (
                x.fieldValue == "hardCubicMeter" ||
                x.fieldValue == "softCubicMeter"
              ) {
                return { ...x, maxValue: null };
              } else if (
                x.fieldValue == "tripHard" ||
                x.fieldValue == "tripSoft"
              ) {
                return { ...x, useEffect: true };
              } else if (x.fieldValue == "driverId") {
                return {
                  ...x,
                  list: res.data.driverDetailList,
                  showValue: "driverName",
                  sentValue: "driverId",
                };
              } else {
                return { ...x };
              }
            });
            setKey(Math.random());
            setPortalfields(arr);
          } else if (res && res.data.statusDescription?.statusCode == 401) {
            dispatch(setLoader(false));
          } else if (res && res.data.statusDescription?.statusCode == 220) {
            let arr = portalFields.map((x) => {
              if (
                x.fieldValue == "hardCubicMeter" ||
                x.fieldValue == "softCubicMeter"
              ) {
                return { ...x, maxValue: null };
              } else if (
                x.fieldValue == "tripHard" ||
                x.fieldValue == "tripSoft"
              ) {
                return { ...x, useEffect: true };
              } else if (x.fieldValue == "driverId") {
                return {
                  ...x,
                  list: [],
                  showValue: "driverName",
                  sentValue: "driverId",
                };
              } else {
                return { ...x };
              }
            });
            setPortalfields(arr);
          }
        });

        // setPreviousData(res.data.vehicleDetails[0]);
      } else {
        toast.warn(res.data?.statusDescription?.description);
        setVehicleVendorList([]);
      }
    });
  };

  const formik = useFormik({
    initialValues: {
      siteId: null,
      shiftId: null,
      tripDate: null,
      siteIdState: null,
      tripDateState: new Date(),
      vehicleTypeId: null,
      vehicleName: "",
      shiftName: "",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      // console.log(values);
      let arr = [];
      let arr2 = [...addedList];

      if (singleArray?.length == 0) {
        toast.error("Atleast one entry is required for submit");
        return;
      }

      if (uploadfiles?.length === 0) {
        toast.error("files are required");
        return;
      }

      let fullData = null;

      singleArray?.forEach((ele) => {
        let formdata = ele;
        console.log(formdata);

        if (ele) {
          formdata["driverName"] = ele.response.driverIdstate.driverName;
        }

        formdata["workingHours"] = Number(ele.workingHours);
        fullData = formdata;
        // arr2.push(fullData);
        arr.push(formdata);
      });
      // console.log(arr);

      const indiaTime = new Date().toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });

      let arr1 = arr.map((x) => {
        return {
          ...x,
          ...x.response,

          tripDate: formik.values.tripDate + " " + indiaTime,
        };
      });

      // let arr2 = [];
      // console.log(arr1);
      dispatch(setLoader(true));
      await saveDetailsTrips(arr1).then((res) => {
        if (res && res.data.statusDescription.statusCode == 200) {
          dispatch(setLoader(false));
          toast.success(res.data.statusDescription.description);
          let arr = [];
          if (res.data.tripdetaillog2?.length > 0) {
            res.data.tripdetaillog2.forEach((x) => {
              arr.push(x.tripId);
            });
          }
          if (res.data.tripdetaillog1?.length > 0) {
            res.data.tripdetaillog1.forEach((x) => {
              arr.push(x.tripId);
            });
          }

          // arr2.push(fullData);
          // setAddedList(arr2);

          uploadfilesApi(arr);
          setSingleArray([]);
          // console.log(arr);
          resetForms();
        } else {
          toast.error(res.data.statusDescription.description);
        }
      });
    },
  });

  useEffect(() => {
    if (
      (formik.values.vehicleTypeId && formik.values.shiftId,
      formik.values.siteId &&
        formik.values.tripDate &&
        formik.values.vehicleName)
    ) {
      resetForms();
      getVendorDetails();
      // getDriverList(formik.values.vehicleTypeId);
      setSearchKey("");
      setSearchState(null);
    }
  }, [
    formik.values.vehicleTypeId,
    formik.values.shiftId,
    formik.values.siteId,
    formik.values.tripDate,
    formik.values.vehicleName,
  ]);

  const resetForms = (type) => {
    if (type) {
      setUploadfiles([]);
    }
    setKey(Math.random());
    // setAddedList([]);
    // setVehicleVendorList([]);
    setPreviousData(null);
    document.getElementById("reset_id")?.click();
    setShowIndex(0);
    setSearchKey("");
    setSearchState(null);
    setSingleArray([]);
    let e;
    // formik.handleReset(e);
    setForcehit(true);
  };

  useEffect(() => {
    if (isLogin) {
      setKey(Math.random());

      // getShiftDetails()
      //   .then(getSites)
      //   .then(getVehiclees)
      //   .then(getVendorDetails);
      getShiftDetails();
      getSites();
    }
  }, [formik.values.vehicleTypeId, forceHit, isLogin]);

  const uploadfilesApi = async (arr) => {
    // console.log(arr);
    let formdata = new FormData();

    formdata.append("tripIds", arr.join(","));

    uploadfiles.forEach((x) => {
      formdata.append("files", x);
    });

    if (uploadfiles.length == 0) {
      toast.error("files not found");
      return;
    }

    formdata.append("userId", localStorage.getItem("userId"));

    await uploadfilesgeneric(formdata, "/trip/v1/save-attachments").then(
      (res) => {
        if (res && res.data.statusDescription.statusCode == 200) {
          // console.log("files saved ");
          setUploadfiles([]);
          setSingleArray([]);
          resetForms();

          setResetTrigger(true);
          // setAddedList(arr1);
          setPreviousData(null);
          if (searchKey != "") {
            setShowIndex(0);
          }
          setShowIndex(0);
          setKey(Math.random());

          setSearchKey("");

          // formik.setFieldValue("vehicleTypeId", formik.values.vehicleTypeId);
          // navigate("/viewTripDetails");
        } else {
          toast.error("Attachment not uploaded");
        }
      }
    );
  };

  return (
    <div className="staff-management">
      {/* First Row - Tabs */}
      <div className="tabs-container margin-bottom-3 tb_colored">
        {vehicleList?.map((x) => {
          return (
            <>
              <button
                key={x.vehicleTypeId}
                className={`tab ${activeTab === x.name ? "active" : ""}`}
                onClick={(e) => {
                  setActiveTab(x.name);
                  setVehicleVendorList([]);

                  formik.handleReset(e);
                  formik.setFieldValue("vehicleTypeId", x.vehicleTypeId);

                  formik.setFieldValue("vehicleName", x.name);
                }}
              >
                {x.name}
              </button>
            </>
          );
        })}
      </div>
      <form>
        {/* Second Row - Controls */}
        <div className="row controls-container mt-3 mx-1">
          <div className="col-md-3 col-12 site_div">
            <FormControl sx={{ padding: "2px" }} fullWidth>
              <InputLabel shrink={true}>
                Site <span className="text text-danger">* </span>
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={formik.values.siteIdState}
                required
                size="small"
                name="siteIdState"
                label="Projects"
                onChange={(e) => {
                  formik.handleChange(e);
                  // console.log(e.target.value);
                  formik.setFieldValue("siteId", e.target.value.siteId);
                }}
                MenuProps={{
                  disableAutoFocusItem: true, // Prevents auto-focusing the first item
                  disableEnforceFocus: true, // Prevents focus trapping
                  disableRestoreFocus: true, // Prevents restoring focus to input
                }}
              >
                <MenuItem value={0} style={{ fontSize: "12px" }}>
                  {" "}
                  Select Site
                </MenuItem>
                {sitesList.length > 0 &&
                  sitesList.map((data) => {
                    return (
                      <MenuItem
                        key={data.siteId}
                        value={data}
                        style={{ fontSize: "11px" }}
                      >
                        {" "}
                        {data.siteName}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-2 col-12 date-picker">
            <input
              type="date"
              name="tripDate"
              value={formik.values.tripDate}
              max={new Date().toISOString().split("T")[0]}
              onChange={(e) => {
                // console.log(e);
                formik.handleChange(e);
              }}
            />
          </div>
          <div className="col-md-4 col-12 radio-group">
            {shiftList?.map((x, i) => {
              return (
                <>
                  <label key={i}>
                    <input
                      type="radio"
                      name="status"
                      value={
                        formik.values.shiftId == x.shiftId
                          ? "active"
                          : "inactive"
                      }
                      checked={formik.values.shiftId == x.shiftId}
                      onChange={(e) => {
                        // setSelectedRadio(x.shiftId);
                        formik.setFieldValue("shiftId", x.shiftId);
                      }}
                    />
                    {x.name}
                  </label>
                </>
              );
            })}
          </div>
          <div className="col-md-1 col-12 go_div">
            <button
              className="btn yellow_btn_1"
              type="button"
              onClick={(e) => {
                getVendorDetails();
                setKey(Math.random());
                setPreviousData(null);
              }}
            >
              {" "}
              Apply <i className="fa fa-left-arrow"></i>{" "}
            </button>

            {isMobile && (
              <button
                className="btn btn-primary mx-1  p-0  yellow_btn_2"
                type="button"
                onClick={(e) => {
                  localStorage.setItem(
                    "vehicleTypeId",
                    formik.values.vehicleTypeId
                  );
                  localStorage.setItem(
                    "vehicleName",
                    formik.values.vehicleName
                  );
                  navigate("/viewTripDetails");
                }}
              >
                View
              </button>
            )}
          </div>
          <button className="d-none" type="reset" id="reset_id">
            {" "}
            Reset{" "}
          </button>
        </div>
      </form>

      {/* Your Existing Card with Form */}
      <Card
        title={`Add ${
          formik.values.vehicleName?.charAt(0).toUpperCase() +
          formik.values.vehicleName?.slice(1)
        } Trip Details  : ${formik.values.siteIdState?.siteName}   >  ${
          formik.values.shiftName
        }   >   ${moment(formik.values.tripDate).format("DD-MMM-YYYY")}`}
      >
        <form onSubmit={handleSubmit}>
          {vehicleVendorList.length > 0 && (
            <div className="row mb-1 srch_row">
              <div className="d-flex justify-content-end col-md-3 col-8  offset-md-9 mb-1 inp_search_div">
                <Autocomplete
                  options={vehicleVendorList}
                  className="inp_search"
                  sx={{ width: 300 }}
                  value={searchState}
                  style={{ padding: "2px" }}
                  getOptionLabel={(option) => option?.registrationNumber || ""}
                  onChange={(e, newValue, reason) => {
                    if (reason == "clear") {
                      setSearchState(null);
                      setSearchKey("");
                      setKey(Math.random());
                      setShowIndex(0);
                      return;
                    }

                    if (newValue) {
                      // // console.log(e.target.value);
                      setSearchState(newValue);
                      setKey(Math.random());

                      setSearchKey(newValue?.registrationNumber);
                      let filter = vehicleVendorList.filter((x) => {
                        return (
                          x.registrationNumber == newValue?.registrationNumber
                        );
                      });
                      // console.log(filter);

                      if (filter?.length > 0) {
                        vehicleVendorList.forEach((x, i) => {
                          if (filter[0].vehicleId == x.vehicleId) {
                            setShowIndex(i);
                            setKey(Math.random());
                          }
                        });
                      }
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Search Vehicle" />
                  )}
                />
                {/* 
                <button
                  className="btn srch_blue"
                  type="button"
                  onClick={(e) => {
                    let filter = vehicleVendorList.filter((x) => {
                      return x.registrationNumber == searchKey;
                    });
                    // console.log(filter);

                    if (filter?.length > 0) {
                      vehicleVendorList.forEach((x, i) => {
                        if (filter[0].vehicleId == x.vehicleId) {
                          setShowIndex(i);
                          setKey(Math.random());
                        }
                      });
                    }
                  }}
                >
                  {" "}
                  <i className="fa fa-search " />
                </button> */}
              </div>
            </div>
          )}

          {vehicleVendorList.length > 0 ? (
            <>
              <div className="container-fluid main_container pb-1 ">
                {vehicleVendorList.map((x, i) => {
                  let arr = [];

                  if (showIndex == i) {
                    return (
                      <TripDetailsForm
                        formFields={portalFields}
                        prefilled={x}
                        formSubmitted={formSubmitted}
                        index={i}
                        key={key}
                        editData={previousData}
                        resetTrigger={resetTrigger}
                        exportData={(e, index) => {
                          // console.log(e);
                          if (e) {
                            x["response"] = e;
                            setResponseList(arr);
                            setFormSubmitted(false);
                          }
                        }}
                        setErrors={(e) => {
                          // console.log(e);
                        }}
                        exportAddition={(e, i) => {
                          setSingleArray([]);
                          console.log(e);
                          x["response"] = e;
                          let filearr = [];

                          Object.keys(e).forEach((x) => {
                            if (x.includes("file")) {
                              console.log(e[x]);
                              e[x].forEach((fl) => {
                                filearr.push(fl);
                              });
                              // filearr.push(e[x][0]);
                            }
                          });
                          console.log(filearr);
                          setUploadfiles(filearr);
                          let arr = [];
                          let arr1 = [...addedList];
                          if (true) {
                            arr.push(x);
                            arr1.push(x);
                            // console.log(x);
                            let aer1 = vehicleVendorList.filter((x1) => {
                              return x1.vehicleId != x.vehicleId;
                            });
                            setSingleArray(arr);
                            let event;

                            setVehicleVendorList(aer1);
                            formik.handleSubmit(event);
                          }
                          // setResetTrigger(true);
                          setAddedList(arr1);
                          // setPreviousData(null);
                          // if (searchKey != "") {
                          //   setShowIndex(0);
                          // }
                          // setShowIndex(0);
                          // setKey(Math.random());

                          // setSearchKey("");
                        }}
                      />
                    );
                  }
                })}
              </div>
              <div className="row mt-3">
                <div className="prev_next d-flex justify-content-end">
                  <Stack spacing={2}>
                    <Pagination
                      onChange={(event, value) => {
                        // console.log(value);
                        setShowIndex(value - 1);
                        setKey(Math.random());
                        setPreviousData(null);
                        // setShowIndex(value);
                      }}
                      page={showIndex + 1}
                      count={
                        vehicleVendorList.length ? vehicleVendorList.length : ""
                      }
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Stack>
                </div>
              </div>
            </>
          ) : addedList?.length > 0 && vehicleVendorList?.length == 0 ? (
            <div className="d-block text-center">
              <h4>All Vehicles Added </h4>
            </div>
          ) : (
            <div className="d-block text-center">
              <h4> Please Select Site ,Date and Shift </h4>
            </div>
          )}
        </form>

        {addedList?.length > 0 && (
          <div>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              {/* <Typography sx={{ mt: 1, mb: 1 }} variant="h6" component="div">
                Trips List
              </Typography> */}
              <Demo>
                <List dense={dense}>
                  {/* <div
                    className="row added_card  d-flex justify-content-between"
                    style={{ fontWeight: "bold" }}
                  >
                    <div className="col-md-auto">Vendor Name</div>
                    <div className="col-md-auto">Vehicle No</div>
                    <div className="col-md-auto">S R</div>
                    <div className="col-md-auto">E R</div>
                    <div className="col-md-auto">Wrk Hr(s)</div>
                    <div className="col-md-auto">H Trip</div>
                    <div className="col-md-auto">S Trip</div>
                    <div className="col-md-auto">Hard Cubic Mtr</div>
                    <div className="col-md-auto">Soft Cubic Mtr</div>
                    <div className="col-md-auto">Trps Ct</div>
                   
                  </div>

                  {addedList.map((x, i) => {
                    return (
                      <>
                        <div className="container-fluid main_container p-2 mt-2   ">
                          <div className="row d-flex justify-content-between ">
                         
                            <div className="col-md-auto">{x?.vendor?.name}</div>
                            <div className="col-md-auto">
                              {x?.registrationNumber}
                            </div>

                            <div className="col-md-auto">
                              {x?.response?.startReading}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.endReading}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.workingHours}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.tripHard}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.tripSoft}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.hardCubicMeter}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.softCubicMeter}
                            </div>
                           
                            <div className="col-md-auto">
                              {x?.response?.tripsCount}
                            </div>
                           
                          </div>
                        </div>
                      </>
                    );
                  })} */}
                  {addedList?.map((x) => {
                    return (
                      <>
                        <div className="container-fluid">
                          <div className="card">
                            <div className="card-body">
                              <div className="main_row_tab">
                                <div className="row">
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Vendor Name</span> <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.vendor?.name}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Vehicle Number</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.registrationNumber}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>S R</span> <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.startReading}
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Driver Name </span> <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.driverIdstate?.driverName}
                                    </div>
                                  </div>
                                  {/* <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Wrk Hr(s)</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.workingHours}
                                    </div>
                                  </div> */}
                                  {/* <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>H Trip</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.tripHard}
                                    </div>
                                  </div> */}
                                </div>
                                {/* 
                                <div className="row">
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>S Trip</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.tripSoft}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span> Hard Cubic Mtr</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.hardCubicMeter}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Soft Cubic Mtr</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.softCubicMeter}
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Trps Ct</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.tripsCount}
                                    </div>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </List>
              </Demo>
            </Grid>
          </div>
        )}

        <div className="form-buttons">
          {true && (
            <div className="w-40">
              {/* <input
                type="file"
                accept="image/*"
                capture="environment" // "user" for selfie camera
                onChange={(e) => {
                  console.log(e.target.files);
                }}
                style={{ marginBottom: "20px" }}
              /> */}

              {/* <TextField
                name="uploadfiles"
                className="inp_choose"
                type="file"
                label="Upload File"
                inputProps={{
                  multiple: true,
                  style: { padding: "8.5px 14px" },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  let files = e.target.files;

                  if (files && files.length > 0) {
                    let fileArray = Array.from(files);

                    setUploadfiles(fileArray);
                    // console.log(fileArray);
                  }
                }}
              /> */}
            </div>
          )}
          {/* <div className="d-flex justify-content-center align-items-center  w-100">
            <button
              type="submit"
              className="btn yellow_btn me-3"
              onClick={(e) => {
                setFormSubmitted(true);

                if (addedList?.length == 0) {
                  toast.error("Add Atleast one entry for submission");
                  return;
                }

                if (uploadfiles?.length == 0) {
                  toast.warn("Files are required");
                  return;
                }

                formik.handleSubmit(e);
              }}
            >
              Submit
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Cancel
            </button>
          </div> */}
        </div>
      </Card>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                Cancel Confirmation
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="cancelclose"
              ></button>
            </div>
            <div className="modal-body">
              Are you want to cancel filling details
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  formik.handleReset(e);
                  setVehicleVendorList([]);
                  setUploadfiles([]);
                  setAddedList([]);
                  setSearchKey("");
                  getVehiclees();
                  setAddedList([]);
                  setKey(Math.random());
                  document.getElementById("cancelclose")?.click();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <DetailModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title="User Details"
        details={detailObj}
        btnTitle={"Logout"}
      /> */}
    </div>
  );
};

export default StaffManagement;
